module.exports = __webpack_public_path__ + "static/media/transferir.ac89cb01.svg";